export default __webpack_public_path__ + "static/clam-f283d92b3552e8b1098328b504531775.webp";